import React from 'react';
import { List as AntList } from 'antd';

const List = ({ items, renderItem }) => {
  return <AntList itemLayout="vertical" dataSource={items} renderItem={renderItem} />;
};

export default List;
